var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M202.9,29.6c-1.4,1.3-1.5,3.4-0.3,4.9c0.8,1,1.3,1.1,6.5,1.3l5.6,0.2l-14.2,14.2l-14.2,14.2l-15.8-8.8c-9.9-5.5-16.2-8.8-17.1-8.8c-1.1,0-4.2,3-19,17.7c-9.8,9.8-17.9,17.8-18.1,17.8S109,77.7,100.4,72c-11.6-7.7-15.9-10.4-16.9-10.4c-1.2,0-3.9,2.5-20.8,19.5c-17.8,17.7-19.5,19.6-19.5,21c0,2,1.8,3.8,3.8,3.8c1.3,0,3.1-1.7,19.3-17.7c9.8-9.8,17.9-17.7,18.1-17.7c0.2,0,7.3,4.7,15.9,10.4c11.5,7.7,15.9,10.4,16.9,10.4c1.2,0,3.7-2.4,19.4-18l18-18l15.8,8.8c9.8,5.5,16.2,8.8,17.1,8.8c1.1,0,3.9-2.6,17.1-15.8l15.8-15.8v5.4c0,5.2,0,5.5,1.2,6.5c1.5,1.5,3.6,1.5,5.1,0l1.2-1.1V41.3V30.7l-1.2-1.1l-1.1-1.2h-10.6H204L202.9,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M11.2,81.2L10,82.3v71.5v71.5l1.2,1.1l1.1,1.2H128h115.7l1.1-1.2c1.5-1.5,1.5-3.6,0-5.1l-1.1-1.2H130.5H17.4v-68.9v-69l-1.2-1.1c-0.7-0.7-1.7-1.2-2.5-1.2C12.8,80.1,11.8,80.5,11.2,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M221.4,81.2l-1.2,1.1v64.1v64.1l1.2,1.1c1.5,1.5,3.6,1.5,5.1,0l1.2-1.1v-64.1V82.3l-1.2-1.1c-0.7-0.7-1.7-1.2-2.5-1.2C223,80.1,222,80.5,221.4,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M151.3,99.6l-1.2,1.1v54.9v54.9l1.2,1.1c1.5,1.5,3.6,1.5,5.1,0l1.2-1.1v-54.9v-54.9l-1.2-1.1c-0.7-0.7-1.7-1.2-2.5-1.2C152.9,98.5,152,98.9,151.3,99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M81.2,118.1l-1.2,1.1v45.7v45.7l1.2,1.1c1.5,1.5,3.6,1.5,5.1,0l1.2-1.1v-45.7v-45.7l-1.2-1.1c-0.7-0.7-1.7-1.2-2.5-1.2C82.9,116.9,81.9,117.3,81.2,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M184.5,118.1l-1.2,1.1v45.7v45.7l1.2,1.1c1.5,1.5,3.6,1.5,5.1,0l1.2-1.1v-45.7v-45.7l-1.2-1.1c-0.7-0.7-1.7-1.2-2.5-1.2C186.1,116.9,185.2,117.3,184.5,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M114.4,136.5l-1.2,1.1v36.5v36.5l1.2,1.1c0.7,0.7,1.7,1.2,2.5,1.2c0.9,0,1.8-0.4,2.5-1.2l1.2-1.1v-36.5v-36.5l-1.2-1.1c-0.7-0.7-1.7-1.2-2.5-1.2C116.1,135.4,115.1,135.8,114.4,136.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M44.3,151.3l-1.2,1.1v29.1v29.1l1.2,1.1c1.5,1.5,3.6,1.5,5.1,0l1.2-1.1v-29.1v-29.1l-1.2-1.1c-0.7-0.7-1.7-1.2-2.5-1.2C46,150.1,45,150.5,44.3,151.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.e941f9460914b84ac6965148936d5f04.svg";
export { ForwardRef as ReactComponent };